import { Tooltip } from "@fluentui/react-components";
import { CommonHelper } from "../../../../utils/common/CommonHelper";

interface IDelayCellProps {
  codes: string[];
  durations: string[];
}

export const DelayCode = ({ codes, durations }: IDelayCellProps) => {
  if (!codes || codes.length === 0) {
    return <></>;
  }

  const tooltipContent = (
    <div>
      {codes.map((code: string, idx: number) => (
        <div key={CommonHelper.getGuid()}>
          Delay Code: {code}/{durations[idx] ?? ""} mins
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip content={tooltipContent} relationship="label">
      <span>{codes.join(",")}</span>
    </Tooltip>
  );
};
